"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Checksum = /** @class */ (function () {
    function Checksum() {
    }
    Checksum.compute = function (data) {
        var computedChecksum = 0;
        ;
        for (var i = 0; i < data.length; i++) {
            computedChecksum = (computedChecksum + data[i]);
        }
        return computedChecksum;
    };
    return Checksum;
}());
exports.Checksum = Checksum;
